import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { API } from "../../../constants/apiPath";
import axios from "axios";

const initialState = {
  isLoading: false,
  appointments: [],
  blockedDates: [],
  myAppointments : [],
};

const THUNK_METHODS = {
  GET_CALENDAR_EVENTS: "appointment/getCalendarEvents",
  GET_MY_CALENDAR_EVENTS: "appointment/getCalendarEvents/my",
  CREATE_APT: "appointment/create",
  UPDATE_STATUS: "appointment/update-status",
};

/* -----------------------------
   GET CALENDAR DATA
------------------------------ */

export const getMyCalenderEvents = createAsyncThunk(
  THUNK_METHODS.GET_MY_CALENDAR_EVENTS,
  async (_, { rejectWithValue }) => {
    try {

      const { data } = await axios({
        method: "GET",
        url: `${process.env.REACT_APP_API_URL}${API.APPOINTMENT.MY}`,
        withCredentials: true,
      });

      return data;

    } catch (error) {
      console.error(error.message);
      return rejectWithValue("Failed to fetch calendar events");
    }
  }
);

export const getCalendarEvents = createAsyncThunk(
  THUNK_METHODS.GET_CALENDAR_EVENTS,
  async (_, { rejectWithValue }) => {
    try {

      const { data } = await axios({
        method: "GET",
        url: `${process.env.REACT_APP_API_URL}${API.APPOINTMENT.GET}`,
        withCredentials: true,
      });

      return data;

    } catch (error) {
      console.error(error.message);
      return rejectWithValue("Failed to fetch calendar events");
    }
  }
);

/* -----------------------------
   BLOCK DATE
------------------------------ */

export const createAppointment = createAsyncThunk(
  THUNK_METHODS.CREATE_APT,
  async (payload, { rejectWithValue }) => {
    try {

      const response = await axios({
        method: "POST",
        url: `${process.env.REACT_APP_API_URL}${API.APPOINTMENT.CREATE}`,
        withCredentials: true,
        data: payload,
      });

      return response.data;

    } catch (error) {
      console.error(error.message);
      return rejectWithValue("Failed to block date");
    }
  }
);

export const updateAppointmentStatus = createAsyncThunk(
  THUNK_METHODS.UPDATE_STATUS,
  async (payload, { rejectWithValue }) => {
    try {

      const response = await axios({
        method: "POST",
        url: `${process.env.REACT_APP_API_URL}${API.APPOINTMENT.UPDATE_STATUS}/${payload.id}`,
        withCredentials: true,
        data: payload,
      });

      return response.data;

    } catch (error) {
      console.error(error.message);
      return rejectWithValue("Failed to block date");
    }
  }
);

export const unblockDate = createAsyncThunk(
  "appointment/unblockDate",
  async (id, { rejectWithValue }) => {

    try {

      const response = await axios({
        method: "POST",
        url: `${process.env.REACT_APP_API_URL}${API.APPOINTMENT.UNBLOCKDATE}/${id}`,
        withCredentials: true,
      });

      return id;

    } catch (error) {
      return rejectWithValue(error.message);
    }

  }
);

/* -----------------------------
   SLICE
------------------------------ */

export const appointmentSlice = createSlice({
  name: "appointment",
  initialState,
  reducers: {},
  extraReducers: (builder) => {

    /* GET CALENDAR */

    builder.addCase(getCalendarEvents.pending, (state) => {
      state.isLoading = true;
    });

    builder.addCase(getCalendarEvents.fulfilled, (state, action) => {
      state.appointments = action.payload.appointments;
      state.blockedDates = action.payload.blockedDates;
      state.isLoading = false;
    });

    builder.addCase(getCalendarEvents.rejected, (state) => {
      state.isLoading = false;
    });


    builder.addCase(getMyCalenderEvents.pending, (state) => {
      state.isLoading = true;
    });

    builder.addCase(getMyCalenderEvents.fulfilled, (state, action) => {
      state.myAppointments = action.payload;
      state.isLoading = false;
    });

    builder.addCase(getMyCalenderEvents.rejected, (state) => {
      state.isLoading = false;
    });

    /* BLOCK DATE */

    builder.addCase(createAppointment.pending, (state) => {
      state.isLoading = true;
    });

    builder.addCase(createAppointment.fulfilled, (state, action) => {
      state.isLoading = false;
    });

    builder.addCase(createAppointment.rejected, (state) => {
      state.isLoading = false;
    });


     builder.addCase(updateAppointmentStatus.pending, (state) => {
      state.isLoading = true;
    });

    builder.addCase(updateAppointmentStatus.fulfilled, (state, action) => {
      state.isLoading = false;
    });

    builder.addCase(updateAppointmentStatus.rejected, (state) => {
      state.isLoading = false;
    });

    /* BLOCK DATE */

    builder.addCase(unblockDate.pending, (state) => {
      state.isLoading = true;
    });

    builder.addCase(unblockDate.fulfilled, (state, action) => {
      state.isLoading = false;
    });

    builder.addCase(unblockDate.rejected, (state) => {
      state.isLoading = false;
    });

  },
});

export default appointmentSlice.reducer;